<form [formGroup]="formGroup" id="step3Form">
  <div class="step3-form-container">
    <div class="row">
      @if (controls.meansOfSubsistence; as meansOfSubsistence) {
        <div class="standard-form-field radio-form-field meansOfSubsistenceField required-field">
          <label [class.invalid]="meansOfSubsistence.touched && meansOfSubsistence.invalid">
            {{ 'PERSONAL_DATA_FORM.MEANS-OF-SUBSISTENCE.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="meansOfSubsistence"
            formControlName="meansOfSubsistence"
            (keydown)="firstInputKeydown($event)"
            [required]="true">
            @for (meanObj of selectsValues.MEANS_OF_SUBSISTENCE; track meanObj; let radioButtonIndex = $index) {
              <mat-radio-button id="meansOfSubsistence-{{ radioButtonIndex }}" [value]="meanObj.value">
                {{ meanObj.label }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      }
    </div>
    @if (controls.meansOfSubsistence.value === 'Inne') {
      <div class="row">
        @if (controls.meansOfSubsistenceOthers; as meansOfSubsistenceOthers) {
          <div class="standard-form-field full-width-field meansOfSubsistenceOthers-field required-field">
            <label
              for="meansOfSubsistenceOthersInput"
              [class.invalid]="meansOfSubsistenceOthers.touched && meansOfSubsistenceOthers.invalid">
              {{ 'PERSONAL_DATA_FORM.MEANS-OF-SUBSISTENCE-SAVINGS-OTHERS.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
              <br />
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="meansOfSubsistenceOthersInput"
                type="text"
                maxLength="200"
                minLength="1"
                placeholder="{{ 'PERSONAL_DATA_FORM.MEANS-OF-SUBSISTENCE-SAVINGS-OTHERS.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="
                  meansOfSubsistenceOthers.touched && meansOfSubsistenceOthers.invalid ? 'true' : null
                "
                [attr.aria-describedby]="
                  meansOfSubsistenceOthers.touched && meansOfSubsistenceOthers.invalid
                    ? 'meansOfSubsistenceOthersError'
                    : null
                "
                [formControl]="meansOfSubsistenceOthers" />
              <!-- ERROR -->
              @if (meansOfSubsistenceOthers.touched && meansOfSubsistenceOthers.invalid) {
                <mat-error id="meansOfSubsistenceOthersError">
                  {{ meansOfSubsistenceOthers.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }
    <div class="row">
      @if (controls.meansOfSubsistenceSavingsAmount; as meansOfSubsistenceSavingsAmount) {
        <div class="standard-form-field three-fourth-field meansOfSubsistenceSavingsAmount-field required-field">
          <label
            for="meansOfSubsistenceSavingsAmountInput"
            [class.invalid]="meansOfSubsistenceSavingsAmount.touched && meansOfSubsistenceSavingsAmount.invalid">
            {{ 'PERSONAL_DATA_FORM.MEANS-OF-SUBSISTENCE-SAVINGS-AMOUNT.MAIN-LABEL-LONG-RESI' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="meansOfSubsistenceSavingsAmountInput"
              type="text"
              maxLength="100"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.MEANS-OF-SUBSISTENCE-SAVINGS-AMOUNT.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="
                meansOfSubsistenceSavingsAmount.touched && meansOfSubsistenceSavingsAmount.invalid ? 'true' : null
              "
              [attr.aria-describedby]="
                meansOfSubsistenceSavingsAmount.touched && meansOfSubsistenceSavingsAmount.invalid
                  ? 'meansOfSubsistenceSavingsAmountError'
                  : null
              "
              [formControl]="controls.meansOfSubsistenceSavingsAmount" />
            <!-- ERROR -->
            @if (meansOfSubsistenceSavingsAmount.touched && meansOfSubsistenceSavingsAmount.invalid) {
              <mat-error id="meansOfSubsistenceSavingsAmountError">
                {{ meansOfSubsistenceSavingsAmount.errors | errorsFormatingAndTranslate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
    <div class="row">
      <div class="standard-form-field radio-form-field medicalInsurance-field required-field">
        <label [class.invalid]="controls.medicalInsurance.touched && controls.medicalInsurance.invalid">
          {{ 'PERSONAL_DATA_FORM.MEDICAL-INSURANCE.MAIN-LABEL' | translate }} *
        </label>
        <mat-radio-group id="medicalInsurance" formControlName="medicalInsurance" [required]="true">
          @for (insuranceObj of selectsValues.MEDICAL_INSURANCE; track insuranceObj) {
            <mat-radio-button [value]="insuranceObj.value">
              {{ insuranceObj.label }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
    </div>
    <div class="row" [class.mark-red-border]="controls.currentlyDetained.value === true && mode === 'employee'">
      @if (controls.currentlyDetained; as currentlyDetained) {
        <div class="standard-form-field radio-form-field currentlyDetained-field required-field">
          <label id="currentlyDetainedLabel" [class.invalid]="currentlyDetained.touched && currentlyDetained.invalid">
            {{ 'PERSONAL_DATA_FORM.CURRENTLY-DETAINED.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="currentlyDetained"
            formControlName="currentlyDetained"
            [required]="true"
            [attr.aria-labelledby]="'currentlyDetainedLabel'"
            [attr.aria-invalid]="currentlyDetained.touched && currentlyDetained.invalid ? 'true' : null"
            (keydown)="firstInputKeydown($event)">
            <mat-radio-button id="currentlyDetained-0" [value]="true">
              {{ 'COMMON.GENERAL.YES' | translate }}
            </mat-radio-button>
            <mat-radio-button [value]="false">
              {{ 'COMMON.GENERAL.NO' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>
    @if (controls.currentlyDetained.value === true) {
      <!-- ====================================================================== 1 ============================= -->
      <div class="row" [class.mark-red-border]="controls.inGuardedCentre.value === true && mode === 'employee'">
        @if (controls.inGuardedCentre; as inGuardedCentre) {
          <div class="standard-form-field radio-form-field inGuardedCentre-field required-field">
            <label id="inGuardedCentreLabel" [class.invalid]="inGuardedCentre.touched && inGuardedCentre.invalid">
              {{ 'PERSONAL_DATA_FORM.DETAINED_IN_GUARDED_CENTRE' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="inGuardedCentre"
              formControlName="inGuardedCentre"
              [required]="true"
              [attr.aria-labelledby]="'inGuardedCentreLabel'"
              [attr.aria-invalid]="inGuardedCentre.touched && inGuardedCentre.invalid ? 'true' : null">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.inGuardedCentre.value === true) {
          @if (controls.inGuardedCentreComment; as inGuardedCentreComment) {
            <div class="standard-form-field three-fourth-field inGuardedCentreComment-field">
              <label
                for="inGuardedCentreComment"
                [class.invalid]="inGuardedCentreComment.touched && inGuardedCentreComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="inGuardedCentreComment"
                  formControlName="inGuardedCentreComment"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="inGuardedCentreComment.touched && inGuardedCentreComment.invalid ? 'true' : null"
                  [attr.aria-describedby]="
                    inGuardedCentreComment.touched && inGuardedCentreComment.invalid
                      ? 'inGuardedCentreCommentError'
                      : null
                  "></textarea>
                <!-- ERROR -->
                @if (inGuardedCentreComment.touched && inGuardedCentreComment.invalid) {
                  <mat-error id="inGuardedCentreCommentError">
                    {{ inGuardedCentreComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 2 ============================= -->
      <div class="row" [class.mark-red-border]="controls.inDetentionCentre.value === true && mode === 'employee'">
        @if (controls.inDetentionCentre; as inDetentionCentre) {
          <div class="standard-form-field radio-form-field inDetentionCentre-field required-field">
            <label id="inDetentionCentreLabel" [class.invalid]="inDetentionCentre.touched && inDetentionCentre.invalid">
              {{ 'PERSONAL_DATA_FORM.IN_DETENTION_CENTRE' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="inDetentionCentre"
              formControlName="inDetentionCentre"
              [required]="true"
              [attr.aria-labelledby]="'inDetentionCentreLabel'"
              [attr.aria-invalid]="inDetentionCentre.touched && inDetentionCentre.invalid ? 'true' : null">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.inDetentionCentre.value === true) {
          @if (controls.inDetentionCentreComment; as inDetentionCentreComment) {
            <div class="standard-form-field three-fourth-field inDetentionCentreComment-field">
              <label
                for="inDetentionCentreComment"
                [class.invalid]="inDetentionCentreComment.touched && inDetentionCentreComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="inDetentionCentreComment"
                  formControlName="inDetentionCentreComment"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    inDetentionCentreComment.touched && inDetentionCentreComment.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    inDetentionCentreComment.touched && inDetentionCentreComment.invalid
                      ? 'inDetentionCentreCommentError'
                      : null
                  "></textarea>
                <!-- ERROR -->
                @if (inDetentionCentreComment.touched && inDetentionCentreComment.invalid) {
                  <mat-error id="inDetentionCentreCommentError">
                    {{ inDetentionCentreComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 3 ============================= -->
      <div class="row" [class.mark-red-border]="controls.hasBanOnLeavingCountry.value === true && mode === 'employee'">
        @if (controls.hasBanOnLeavingCountry; as hasBanOnLeavingCountry) {
          <div class="standard-form-field radio-form-field hasBanOnLeavingCountry-field required-field">
            <label
              id="hasBanOnLeavingCountryLabel"
              [class.invalid]="hasBanOnLeavingCountry.touched && hasBanOnLeavingCountry.invalid">
              {{ 'PERSONAL_DATA_FORM.HAS_BAN_ON_LEAVING_THE_COUNTRY' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="hasBanOnLeavingCountry"
              formControlName="hasBanOnLeavingCountry"
              [required]="true"
              [attr.aria-labelledby]="'hasBanOnLeavingCountryLabel'"
              [attr.aria-invalid]="hasBanOnLeavingCountry.touched && hasBanOnLeavingCountry.invalid ? 'true' : null">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.hasBanOnLeavingCountry.value === true) {
          @if (controls.hasBanOnLeavingCountryComment; as hasBanOnLeavingCountryComment) {
            <div class="standard-form-field three-fourth-field hasBanOnLeavingCountryComment-field">
              <label
                for="hasBanOnLeavingCountryComment"
                [class.invalid]="hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="hasBanOnLeavingCountryComment"
                  formControlName="hasBanOnLeavingCountryComment"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid
                      ? 'hasBanOnLeavingCountryCommentError'
                      : null
                  "></textarea>
                <!-- ERROR -->
                @if (hasBanOnLeavingCountryComment.touched && hasBanOnLeavingCountryComment.invalid) {
                  <mat-error id="hasBanOnLeavingCountryCommentError">
                    {{ hasBanOnLeavingCountryComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 4 ============================= -->
      <div
        class="row"
        [class.mark-red-border]="controls.hasSentenceOfImprisonment.value === true && mode === 'employee'">
        @if (controls.hasSentenceOfImprisonment; as hasSentenceOfImprisonment) {
          <div class="standard-form-field radio-form-field hasSentenceOfImprisonment-field required-field">
            <label
              id="hasSentenceOfImprisonmentLabel"
              [class.invalid]="hasSentenceOfImprisonment.touched && hasSentenceOfImprisonment.invalid">
              {{ 'PERSONAL_DATA_FORM.SENTENCED_IMPRISONMENT' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="hasSentenceOfImprisonment"
              formControlName="hasSentenceOfImprisonment"
              [required]="true"
              [attr.aria-labelledby]="'hasSentenceOfImprisonmentLabel'"
              [attr.aria-invalid]="
                hasSentenceOfImprisonment.touched && hasSentenceOfImprisonment.invalid ? 'true' : null
              ">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.hasSentenceOfImprisonment.value === true) {
          @if (controls.hasSentenceOfImprisonmentComment; as hasSentenceOfImprisonmentComment) {
            <div class="standard-form-field three-fourth-field hasSentenceOfImprisonmentComment-field">
              <label
                for="hasSentenceOfImprisonmentComment"
                [class.invalid]="hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="hasSentenceOfImprisonmentComment"
                  formControlName="hasSentenceOfImprisonmentComment"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid
                      ? 'hasSentenceOfImprisonmentCommentError'
                      : null
                  "></textarea>
                <!-- ERROR -->
                @if (hasSentenceOfImprisonmentComment.touched && hasSentenceOfImprisonmentComment.invalid) {
                  <mat-error id="hasSentenceOfImprisonmentCommentError">
                    {{ hasSentenceOfImprisonmentComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
      <!-- ====================================================================== 5 ============================= -->
      <div class="row" [class.mark-red-border]="controls.temporarilyArrested.value === true && mode === 'employee'">
        @if (controls.temporarilyArrested; as temporarilyArrested) {
          <div class="standard-form-field radio-form-field temporarilyArrested-field required-field">
            <label
              id="temporarilyArrestedLabel"
              [class.invalid]="temporarilyArrested.touched && temporarilyArrested.invalid">
              {{ 'PERSONAL_DATA_FORM.TEMPORARILY_ARRESTED' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-radio-group
              id="temporarilyArrested"
              formControlName="temporarilyArrested"
              [required]="true"
              [attr.aria-labelledby]="'temporarilyArrestedLabel'"
              [attr.aria-invalid]="temporarilyArrested.touched && temporarilyArrested.invalid ? 'true' : null">
              <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
              <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        @if (controls.temporarilyArrested.value === true) {
          @if (controls.temporarilyArrestedComment; as temporarilyArrestedComment) {
            <div class="standard-form-field three-fourth-field temporarilyArrestedComment-field">
              <label
                for="temporarilyArrestedComment"
                [class.invalid]="temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid">
                {{ 'COMMON.LABEL.COMMENT' | translate }}
              </label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  id="temporarilyArrestedComment"
                  formControlName="temporarilyArrestedComment"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="2"
                  cdkAutosizeMaxRows="9"
                  [attr.aria-required]="false"
                  [attr.aria-invalid]="
                    temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid ? 'true' : null
                  "
                  [attr.aria-describedby]="
                    temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid
                      ? 'temporarilyArrestedCommentError'
                      : null
                  "></textarea>
                <!-- ERROR -->
                @if (temporarilyArrestedComment.touched && temporarilyArrestedComment.invalid) {
                  <mat-error id="temporarilyArrestedCommentError">
                    {{ temporarilyArrestedComment.errors | errorsFormatingAndTranslate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          }
        }
      </div>
    }
    <div class="row">
      @if (controls.wasSentencedInPoland; as wasSentencedInPoland) {
        <div class="standard-form-field radio-form-field wasSentencedInPoland-field required-field">
          <label
            id="wasSentencedInPolandLabel"
            [class.invalid]="wasSentencedInPoland.touched && wasSentencedInPoland.invalid">
            {{ 'PERSONAL_DATA_FORM.WAS-SENTENCED-IN-POLAND.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="wasSentencedInPoland"
            formControlName="wasSentencedInPoland"
            [required]="true"
            [attr.aria-labelledby]="'wasSentencedInPolandLabel'"
            [attr.aria-invalid]="wasSentencedInPoland.touched && wasSentencedInPoland.invalid ? 'true' : null">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.wasSentencedInPoland.value === true) {
        @if (controls.sentenceReason; as sentenceReason) {
          <div class="standard-form-field three-fourth-field sentenceReason-field">
            <label for="applicantSentenceReason" [class.invalid]="sentenceReason.touched && sentenceReason.invalid">
              {{ 'PERSONAL_DATA_FORM.SENTENCE-REASON.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="applicantSentenceReason"
                formControlName="sentenceReason"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"
                [attr.aria-required]="false"
                [attr.aria-invalid]="sentenceReason.touched && sentenceReason.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  sentenceReason.touched && sentenceReason.invalid ? 'sentenceReasonError' : null
                "></textarea>
              <!-- ERROR -->
              @if (sentenceReason.touched && sentenceReason.invalid) {
                <mat-error id="sentenceReasonError">
                  {{ sentenceReason.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      }
    </div>
    <div class="row">
      @if (controls.currentlySubjectOfProceedings; as currentlySubjectOfProceedings) {
        <div class="standard-form-field radio-form-field currentlySubjectOfProceedings-field required-field">
          <label
            id="currentlySubjectOfProceedingsLabel"
            [class.invalid]="currentlySubjectOfProceedings.touched && currentlySubjectOfProceedings.invalid">
            {{ 'PERSONAL_DATA_FORM.CURRENTLY-SUBJECT-OF-PROCEEDINGS.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="currentlySubjectOfProceedings"
            formControlName="currentlySubjectOfProceedings"
            [required]="true"
            [attr.aria-labelledby]="'currentlySubjectOfProceedingsLabel'"
            [attr.aria-invalid]="
              currentlySubjectOfProceedings.touched && currentlySubjectOfProceedings.invalid ? 'true' : null
            ">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
      @if (controls.currentlySubjectOfProceedings.value === true) {
        @if (controls.proceedingsReason; as proceedingsReason) {
          <div class="standard-form-field three-fourth-field proceedingsReason-field">
            <label
              for="applicantProceedingsReason"
              [class.invalid]="proceedingsReason.touched && proceedingsReason.invalid">
              {{ 'PERSONAL_DATA_FORM.PROCEEDINGS-REASON.MAIN-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <textarea
                matInput
                id="applicantProceedingsReason"
                formControlName="proceedingsReason"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                cdkAutosizeMaxRows="9"
                [attr.aria-required]="false"
                [attr.aria-invalid]="proceedingsReason.touched && proceedingsReason.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  proceedingsReason.touched && proceedingsReason.invalid ? 'proceedingsReasonError' : null
                "></textarea>
              <!-- ERROR -->
              @if (proceedingsReason.touched && proceedingsReason.invalid) {
                <mat-error id="proceedingsReasonError">
                  {{ proceedingsReason.errors | errorsFormatingAndTranslate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      }
    </div>
    <div class="row">
      @if (controls.isComplyingWithFiscalObligation; as isComplyingWithFiscalObligation) {
        <div class="standard-form-field radio-form-field isComplyingWithFiscalObligation-field required-field">
          <label
            id="isComplyingWithFiscalObligationLabel"
            [class.invalid]="isComplyingWithFiscalObligation.touched && isComplyingWithFiscalObligation.invalid">
            {{ 'PERSONAL_DATA_FORM.IS-COMPLYING-WITH-FISCAL-OBLIGATION.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-radio-group
            id="isComplyingWithFiscalObligation"
            formControlName="isComplyingWithFiscalObligation"
            [required]="true"
            [attr.aria-labelledby]="'isComplyingWithFiscalObligationLabel'"
            [attr.aria-invalid]="
              isComplyingWithFiscalObligation.touched && isComplyingWithFiscalObligation.invalid ? 'true' : null
            "
            (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()">
            <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
            <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
          </mat-radio-group>
        </div>
      }
    </div>
  </div>
</form>

<ng-template #applyingForExperienceTooltipTemplate>
  <div style="display: flex; flex-direction: column">
    <h3 style="margin: 5px 0 5px 5px">{{ 'PERSONAL_DATA_FORM.EXAMPLE' | translate }}</h3>
    <span translate="EXPERIENCE_TOOLTIP.ROW_1"></span>
    <span translate="EXPERIENCE_TOOLTIP.ROW_2"></span>
    <span translate="EXPERIENCE_TOOLTIP.ROW_3"></span>
    <span translate="EXPERIENCE_TOOLTIP.ROW_4"></span>
    <span translate="EXPERIENCE_TOOLTIP.ROW_5"></span>
  </div>
</ng-template>
